const optionsHash = (options) =>
  options.split(',').map((option, i) => ({
    id: i,
    label: option,
    value: option,
  }));

/* eslint-disable camelcase */
const FIELD_SCHEMA_MAPPING = {
  text_field: ({ label }) => ({
    type: 'Text',
    label,
    validators: [{ type: 'isNotEmptyString' }],
  }),
  check_box: ({ label, check_box_label }) => ({
    type: 'Boolean',
    label,
    labelText: check_box_label,
  }),
  select: ({ label, options }) => ({
    type: 'Select',
    label,
    options: optionsHash(options),
    selectProps: {
      isFluid: true,
      isFullWidth: true,
      isClearable: true,
    },
  }),
  radio_button: ({ label, options }) => ({
    type: 'Radio',
    label,
    options: optionsHash(options),
  }),
};

export default ({ adminSettings, isChildLocale = false }) => {
  if (isChildLocale) return {};

  const customFieldSchemas = adminSettings.data?.custom_fields?.courses || {};

  return Object.entries(customFieldSchemas).reduce((memo, [key, schema]) => {
    const fieldSchema = FIELD_SCHEMA_MAPPING[schema.type]?.(schema);
    return fieldSchema ? { ...memo, [key]: fieldSchema } : memo;
  }, {});
};
